export const getNotificationAlerts = (state) => {
  return state.notificationAlerts.list.data
    ? state.notificationAlerts.list.data
    : [];
};

export const getNotificationAlertsPaging = (state) => {
  return state.notificationAlerts.list.paging || {};
};

export const getNotificationAlertsUnreadCount = (state) => {
  return state.notificationAlerts.list.unreadCount || 0;
};

export const getIsNotificationAlertsFetching = (state) =>
  state.notificationAlerts.list.isFetching;

export const getIsNotificationAlertsUpdatedAt = (state) =>
  state.notificationAlerts.list.updatedAt;
